<template>
  <div class="perms-actions">
    <div class="listing-title">{{ $t(title) }}</div>
    <div class="search">
      <tol-type-ahead
        :search-params="{
          url: `/perm-placements`,
          searchKeys: ['searchParam'],
          urlParams
        }"
        :results-in-dropdown="false"
        @filtered="onFiltered($event)"
      >
      </tol-type-ahead>
    </div>

    <div class="listing-actions">
      <div class="action-buttons">
        <router-link to="/perm-placements/create">
          <TolAltButton label="New perm placement" icon-name="plus" />
        </router-link>
        <TolAltButton label="Export to excel" icon-name="file-excel" @click="exportAsExcel" />
      </div>
    </div>
  </div>
</template>

<script>
import TolTypeAhead from '@/app/components/TolTypeAhead';
import TolAltButton from '@/app/components/TolAltButton';
import {
  PermPlacementsListingActions,
  PermPlacementsListingGetters
} from '../perm-placements-listing.keys';

export default {
  name: 'PermPlacementsActions',
  components: {
    TolTypeAhead,
    TolAltButton
  },
  props: {
    title: {
      type: String,
      default: 'permPlacement.listing.actions.titleAll'
    }
  },
  computed: {
    filters() {
      return this.$store.getters[PermPlacementsListingGetters.PermPlacementsFilters];
    },
    sortParams() {
      return this.$store.getters[PermPlacementsListingGetters.PermPlacementsSortParams];
    },
    paginationParams() {
      return this.$store.getters[PermPlacementsListingGetters.PermPlacementsPaginationParams];
    },
    urlParams() {
      return {
        ...this.filters.dateRangeFilters,
        ...this.filters.statusFilters,
        ...this.sortParams,
        ...this.paginationParams
      };
    }
  },
  methods: {
    exportAsExcel() {},
    onFiltered(event) {
      this.$store.dispatch(PermPlacementsListingActions.FilterListBySearchKey, {
        filteredItems: event.data,
        isSearchKey: event.isSearchKey,
        searchParam: event.searchParam
      });
    }
  }
};
</script>

<style scopd lang="scss">
@import '../../../../../styles/colors.scss';
@import '../../../../../styles/variables.scss';

.perms-actions {
  display: flex;
  align-items: center;
  background-color: $background-level-2;
  padding: 60px;
  .listing-title {
    color: $text-color-dark;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: -0.24px;
    line-height: 28px;
    flex-basis: 20%;
  }
  .search {
    flex-basis: 60%;
  }

  .listing-actions {
    margin-left: auto;
    display: flex;
    flex-basis: 20%;
    align-items: center;
    .action-buttons {
      display: flex;
      margin-left: auto;
      a {
        text-decoration: none;
        color: inherit;
        //width: 130px;
        .wrapper {
          width: 160px;
        }
      }
    }
  }
}
</style>
